import {lazy} from 'react';
import WebPaths from "../paths/web";

const WebRoutes = [
    {
        path: WebPaths.home,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Home'))
    },
    {
        path: WebPaths.guide,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Guide'))
    },
    {
        path: WebPaths.cart,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Cart'))
    },
    {
        path: WebPaths.shipping,
        layout: 'BlankLayout',
        component: lazy(() => import('@src/views/web/pages/Shipping')),
        auth: true
    },
    {
        path: WebPaths.payment,
        layout: 'BlankLayout',
        component: lazy(() => import('@src/views/web/pages/Payment')),
        auth: true
    },
    {
        path: WebPaths.paymentResult,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/PaymentResult'))
    },
    {
        path: `${WebPaths.tag()}/:slug`,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/ProductsTags'))
    },
    {
        path: `${WebPaths.product()}/:slug`,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Product'))
    },
    {
        path: WebPaths.products(),
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Products'))
    },
    {
        path: `${WebPaths.category()}/:slug`,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Products'))
    },
    {
        path: `${WebPaths.articles()}/:slug`,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Articles'))
    },
    {
        path: `${WebPaths.article()}/:slug`,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Article'))
    },
    {
        path: WebPaths.articles(),
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Articles'))
    },
    {
        path: `${WebPaths.commercialPartner()}/:slug`,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/CommercialPartner'))
    },
    {
        path: WebPaths.commercialPartners(),
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/CommercialPartners'))
    },
    {
        path: `${WebPaths.commercialPartners()}/:slug`,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/CommercialPartners'))
    },
    {
        path: `${WebPaths.services()}/:slug`,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Services'))
    },
    {
        path: `${WebPaths.service()}/:slug`,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Service'))
    },
    {
        path: WebPaths.services(),
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Services'))
    },
    {
        path: `${WebPaths.catalogs()}/:slug`,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Catalogs'))
    },
    {
        path: WebPaths.catalogs(),
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Catalogs'))
    },
    {
        path: WebPaths.rules,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Rules'))
    },
    {
        path: WebPaths.aboutUs,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/AboutUs'))
    },
    {
        path: WebPaths.contactUs,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/ContactUs'))
    },
    {
        path: WebPaths.ReservationRequest(),
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/ReservationRequest'))
    },
    {
        path: WebPaths.gallery(),
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Gallery'))
    },
    {
        path: WebPaths.businessGallery,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/PhotoGallery'))
    },
    {
        path: WebPaths.customerBrand,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/PartiesToTheContract'))
    },
    {
        path: `${WebPaths.links()}/:code`,
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/pages/Links'))
    },
    {
        path: WebPaths.errors["401"],
        layout: 'BlankLayout',
        component: lazy(() => import('@errorViews/NotAuthorized'))
    },
    {
        path: WebPaths.errors["403"],
        layout: 'BlankLayout',
        component: lazy(() => import('@errorViews/403'))
    },
    {
        path: WebPaths.errors["404"],
        layout: 'BlankLayout',
        component: lazy(() => import('@errorViews/Error')),
        disabled: true
    },
    {
        path: WebPaths.errors["500"],
        layout: 'BlankLayout',
        component: lazy(() => import('@errorViews/500'))
    },

]

export default WebRoutes
